import { makeAutoObservable, runInAction } from 'mobx';

import {
  frontApi,
  API_ROUTES
} from '_app/api';
// import toast from 'utils/toast';

export class LanguagesStore {
  constructor() {
    makeAutoObservable(this);
  }

  isLoading = false;

  languages = [];

  meta = {};

  errors = {};

  fetchLanguages = async () => {
    try {
      const { data } = await frontApi(API_ROUTES.languages.all);

      runInAction(() => {
        this.languages = data;
      });

    } catch (error) {
      console.error(error);
    }
  };
}

export default new LanguagesStore();
